import React, {memo, useEffect, useState} from "react";
import {useRequest} from "ahooks";
import moment from "moment";
import {Justify, Icon, H3, Button, H5, Bubble} from "tea-component";
import SvgIcon from "@/pages/home/components/SvgIcon";
import AbnormalPage from "@/pages/datalab/components/AbnormalPage";
import ToolCard from "@/pages/aigc/components/AigcCard";
import AigcCoverImage from "@/pages/aigc/components/AigcCoverImage";
import {unitConversion} from "@/pages/datalab/utils/utils";
import {getToolDetail, getToolSimilar} from "@/pages/aigc/pages/Tools/service";
import {useAigcIntl} from "@/pages/aigc/utils/utils";
import "./index.scss";


export default function (props) {
  const {toolId, changeToolDetailId} = props;
  const [toolDetail, setToolDetail] = useState({});
  const [similarTools, setSimilarTools] = useState([]);
  const {formatMessage: toolsFormatMessage, isEn} = useAigcIntl("tools");
	
  // 请求工具详情数据
  const {
    loading: toolDetailLoading,
    error: toolDetailError,
    run: toolDetailRun,
  } = useRequest(
    (id) => {
      return getToolDetail({id});
    },
    {
      manual: true,
      onSuccess(data) {
        setToolDetail(data || {});
      },
      onError(e) {
      }
    }
  );
	
  // 请求工具相似推荐
  const {
    loading: similarToolLoading,
    error: similarToolError,
    run: similarToolRun,
  } = useRequest(
    (id) => {
      return getToolSimilar({id, pagesize: 3});
    },
    {
      manual: true,
      onSuccess(data) {
        setSimilarTools(data?.list?.splice(0, 3) || []);
      },
      onError(e) {
      }
    }
  );
	
  useEffect(() => {
    if (!toolId) return;
    toolDetailRun(toolId);
    similarToolRun(toolId);
  }, [toolId]);
	
  return (
    <div className={"tool-detail"}>
			
      <Justify
        className={"tool-detail-head"}
        left={toolsFormatMessage("app_details")}
        right={(<Icon type="close" onClick={() => changeToolDetailId(null)}/>)}
      />
      <AbnormalPage
        status={toolDetailLoading ? "loading" : (toolDetailError ? "error" : "normal")}
        style={{backgroundColor: "#ffffff", height: "655px", width: "100%"}}
      >
				
        <Justify
          top
          className={"tool-detail-info"}
          left={(<ToolDetailInfoLeft toolDetail={toolDetail} toolsFormatMessage={toolsFormatMessage} isEn={isEn} toolsFormatMessage={toolsFormatMessage}/>)}
          right={(<AigcCoverImage src={toolDetail?.cover} className={"detail-img"}/>)}
        />
				
        <div className={"tool-detail-description"} dangerouslySetInnerHTML={{__html: (isEn ? (toolDetail?.content_en || toolDetail?.content) : toolDetail?.content) || (isEn ? toolDetail?.description_en : toolDetail?.description)}}>
				
        </div>
				
				
        <AbnormalPage
          status={similarToolLoading ? "loading" : (similarToolError ? "error" : "normal")}
          style={{backgroundColor: "#ffffff", height: "334px", width: "100%"}}
        >
          {
            similarTools?.length > 0 ? (<div className={"tool-detail-similar"}>
              <H5>{toolsFormatMessage("similar")}</H5>
              <div className={"similar-tool-list"}>
                {
                  similarTools?.map((tool) => {
                    const {
                      id,
                      cover,
                      name_en,
                      name,
                      create_time,
                      user_name,
                      view_count,
                      ai_tool_type
                    } = tool || {};
                    const isNew = moment().diff(moment(create_time), "hour") <= 24;
                    return (
                      <ToolCard
                        className={"similar-tool-card"}
                        key={id}
                        isNew={isNew}
                        coverImgSrc={cover}
                        title={{
                          icon: (<SvgIcon className={"card-title-icon"} type={`aigc-${ai_tool_type}`}/>),
                          text: isEn ? name_en : name
                        }}
                        footer={{
                          left: user_name,
                          right: (
                            <span className={"card-views"}><SvgIcon type={"open-eyes"}/>{unitConversion(view_count)}
                            </span>)
                        }}
                        onClick={() => {
                          changeToolDetailId(id);
                        }}
                      />
                    );
                  })
                }
							
              </div>
            </div>) : ""
          }
				
        </AbnormalPage>
			
      </AbnormalPage>
    </div>
  );
}

const ToolDetailInfoLeft = memo(({toolDetail, toolsFormatMessage, isEn}) => {
  const {
    user_name,
    name,
    name_en,
    url,
    tag_names,
    tag_names_en,
    view_count,
    create_time,
    ai_tool_type
  } = toolDetail || {};
  const tagStr = (isEn ? tag_names_en : tag_names)?.split(",");
	
  return (
    <>
      <H3 className={"tool-detail-title"}>{isEn ? name_en : name}</H3>
      <div className={"tool-detail-tags"}>
        {
          tagStr?.map(str => str ? (<span key={str} className={"tool-detail-tag"}>{str}</span>) : "")
        }
      </div>
      <div className={"small-infos"}>
        <SvgIcon type={`aigc-${ai_tool_type}`}/>{toolsFormatMessage(ai_tool_type)}
        <span className={"divider-line"}/>
        {user_name}
        <span className={"divider-line"}/>
        {moment(create_time).format("YYYY-MM-DD")}
        <span className={"divider-line"}/>
        {toolsFormatMessage("tag_internal")}
        <span className={"divider-line"}/>
        <SvgIcon type={"open-eyes"}/>{unitConversion(view_count)}
      </div>
			
      <div>
        <Button
          type={"primary"}
          className={"jump-btn"}
          onClick={() => {
            window.open(url);
          }}
        >
          {toolsFormatMessage("access_details")} &nbsp;<SvgIcon type={"aigc-jump"}/>
        </Button>
        <Bubble
          content={toolsFormatMessage("contact")}
          dark
        >
          <Button type={"link"}>{toolsFormatMessage("contact_admin")}</Button>
        </Bubble>
				
      </div>
    </>
  );
});
